
<div class="overlay" >
    <div class="LoaderBalls">
        <div class="LoaderBalls__item"></div>
        <div class="LoaderBalls__item"></div>
        <div class="LoaderBalls__item"></div>
    </div>
    <!-- <br>
    <h2 class="text-white">Please Wait {{count}} ....</h2> -->
</div>